export default "__VITE_ASSET__54beab9e__"